export const verificationNotificationType = {
    pleaseVerifyYourEmail: 'please_verify_your_email',
    emailVerificationLinkSent: 'email_verification_link_sent',
    emailSuccessfullyVerified: 'email_successfully_verified'
};

export const verificationNotificationTypes = Object.values(verificationNotificationType);